
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";

interface InputFieldProps {
  form: UseFormReturn<any>;
  name: string;
  label: string;
  placeholder?: string;
  type?: string;
  autoFocus?: boolean;
}

export const InputField = ({ 
  form, 
  name, 
  label, 
  placeholder, 
  type = "text",
  autoFocus = false 
}: InputFieldProps) => {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <FormControl>
            <Input
              placeholder={placeholder}
              type={type}
              autoFocus={autoFocus}
              autoComplete="off"
              {...field}
              onFocus={(e) => {
                // Only prevent focus if it's not from a user interaction
                if (!e.isTrusted) {
                  e.target.blur();
                }
              }}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
